export default {"src":"/_next/static/media/facebook.1318e2b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};